const cartDrawerForBranding = document.querySelector('[data-cart-drawer]');
const _z9 = Object.freeze({
  store_logo: cartDrawerForBranding.dataset.storeLogo,
});

window._z9 = _z9;

const checkoutUrlWithLogo = href => {
  const checkoutUrl = new URL(href, window.location.href);
  checkoutUrl.searchParams.set('store_logo', _z9.store_logo);
  return checkoutUrl.toString();
};

document.querySelectorAll('[data-checkout-action]').forEach(link => {
  link.href = checkoutUrlWithLogo(link.href);
  link.addEventListener('click', async event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.dataset.checkoutPending) return;
    link.dataset.checkoutPending = 'true';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { store_logo: _z9.store_logo } }),
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to attach the store logo to checkout.');
    } catch (error) {
      console.error('[CartActions] Could not update the store_logo cart attribute.', error);
    }

    window.location.assign(link.href);
  });
});
